import { useLocation, Navigate } from "react-router-dom";
import PackageConfirmationView from "../components/packages/PackageConfirmationView";

export default function BookingConfirmation() {
  const location = useLocation();
  const confirmation = location.state?.confirmation;

  if (!confirmation) {
    return <Navigate to="/golf-getaways" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-12">
      <PackageConfirmationView confirmation={confirmation} />
    </div>
  );
}
